import { useMatch } from "@/api/services/admin/match";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { MatchForm } from "@/features/match/components/MatchForm";
import { convertMatchResToForm } from "@/features/match/utils/converts";
import { AppRoutes } from "@/routes/config";
import { isNumber } from "@/utils/number";
import { getDynamicRoute } from "@/utils/url";
import { Box, Stack, styled } from "@mui/material";
import { FC, useEffect } from "react";
import { useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

type TMatchEditPageProps = {};

export const MatchEditPage: FC<TMatchEditPageProps> = () => {
  const formRef = useRef<{ submit: () => void }>(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: matchResult, isLoading, isError } = useMatch();
  const matchData = matchResult?.data;

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(AppRoutes.duringContractList, { replace: true });
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !matchData)) {
      navigate(AppRoutes.duringContractList, { replace: true });
    }
  }, [id, isLoading, isError, matchData, navigate]);

  if (isLoading || !matchData) return <LoadingPage />;

  return (
    <MatchCreateWrapper sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <Stack gap={4}>
          <TopPage title="紹介会社の編集" backUrl={getDynamicRoute(AppRoutes.matchDetail, { id: matchData.id })} enablePageBack={false} />
          <MatchForm previousData={convertMatchResToForm(matchData)} ref={formRef} />
        </Stack>
      </Box>
    </MatchCreateWrapper>
  );
};

const MatchCreateWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
